import { Component, Input } from '@angular/core';
import { DebugService } from 'core-lib';
import { Popover } from 'primeng/popover';

@Component({
    selector: 'app-availability-debugview',
    imports: [Popover],
    templateUrl: './availability-debugview.component.html',
    styleUrl: './availability-debugview.component.scss'
})
export class AvailabilityDebugviewComponent {
  @Input() rate:any;
  
  isDebugMode:boolean = false;

  constructor(private debug: DebugService) {
    
    this.isDebugMode = this.debug.isDebugMode;
    
  }


}
